export const CSV_DELIMITER = ';';
export const HYPHEN = '-';
export const ELLIPSIS = '...';

// HASURA CLAIMS
export const HASURA_CLAIM_NAMESPACE = 'https://hasura.io/jwt/claims';
export const HASURA_CLAIM_USER_ID = 'x-hasura-user-id';
export const HASURA_CLAIM_ROLE = 'x-hasura-default-role';
export const HASURA_CLAIM_ORG_ID = 'x-hasura-org-id';
export const HASURA_CLAIM_ADMIN_SECRET = 'x-hasura-admin-secret';
